import {createSelector} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';
import {AIS3_SLICE} from 'store/slices/ais-slice/ais-slice-constants';

const selectAisSliceState = (state: TAppState) => state[AIS3_SLICE];

export const selectAisOrganizationStructureData = createSelector(
    selectAisSliceState,
    ({organizationStructure}) => organizationStructure,
);
